<template>
  <a-card
    :bordered="true"
    class="header-solid h-full"
    :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }"
    :loading="loading"
  >
    <template v-if="withTitle" #title>
      <h4 class="m-text-header-thin m-remove">{{ title }}</h4>
    </template>
    <template slot="extra" class="mb-0">
      <!-- <a-button type="primary"> VIEW ALL </a-button> -->
    </template>
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :style="customStyle"
    />
  </a-card>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: "BarChart",
  components: {
    Bar
  },
  props: {
    chartId: {
      type: String,
      default: "bar-chart"
    },
    title: {
      type: String
    },
    chartData: {
      type: Object,
      default: () => ({
        labels: [],
        datasets: []
      })
    },
    isHorizontal: {
      type: Boolean,
      default: false
    },
    customStyle: {
      type: Object,
      default: () => ({
        position: "relative",
        "min-height": "300px"
      })
    },
    withTitle: {
      type: Boolean,
      default: () => true
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        indexAxis: this.isHorizontal ? "y" : "x",
        plugins: {
          legend: {
            position: "bottom"
          },
          // title: {
          //   display: this.title ? true : false,
          //   text: this.title,
          //   font: {
          //     size: 20
          //   }
          // }
        }
      }
    };
  }
};
</script>
